import { THomeTanquerayProps } from "../type";
import { DdpVideo } from "@/components/shared/DdpVideo";
import { TanquerayBack } from "@/components/shared/Tanqueray/TanquerayBack";
import { DdpCta } from "@/components/shared/DdpCta";
import { useCmsStore } from "@/components/AppHooks";
import { useEffect } from "react";
import { tracking } from "@/shared/tracking";
import { UtilPrevBack } from "@/shared/utils";
export function HomeTanqueray(props: THomeTanquerayProps) {
    const { backgroundVideo, title, description, cTA } = props
    const { localeData: {
        topLabelTanqueray
    } } = useCmsStore()!
    // useEffect(() => {
    //     tracking({
    //         "event": "custom_event",
    //         "event_name": "quiz_start"
    //     })
    // }, [])
    return <div className="page-tanqueray-home">
        <div className="background-video-wrapper">
            <DdpVideo video={backgroundVideo[0]} autoPlay muted loop>
                <div className="content-wrapper tanqueray-grid">
                    <div className="top-wrapper">
                        <TanquerayBack color="white" onClick={()=>{
                             UtilPrevBack('/landing').then((res) => {
                                 if (res) {
                                    history.back()
                                 }
                             })
                        }} />
                        <div className="top-label">{topLabelTanqueray}</div>
                        <div className="title">{title}</div>
                        <div className="description" dangerouslySetInnerHTML={{ __html: description }} />
                    </div>
                    <DdpCta className="cta-start-quiz white" cta={cTA[0]} />
                </div>
            </DdpVideo>
        </div>

    </div>
}